import { Model } from '@/models/Model'

export class LockSubChamber extends Model {
	protected jsonApiType = 'lockSubChambers'
}
